import React from 'react';

import { INotification } from '../../declarations';

import './NotificationBoxStyle.less';

export interface INotificationBoxProps {
  notifications: INotification[];
  inModal?: boolean;
}

const NotificationBox: React.SFC<INotificationBoxProps> = (props: INotificationBoxProps) => {
  const { inModal, notifications } = props;
  return (
    <div className="od-notifications-box od-base-box box no-padding">
      <div className={`notification-body${inModal ? '-in-modal' : ''}`}>
        {notifications.map((notification, idx) => (
          <section key={`${notification.title}${idx}`} className="row notification">
            <div className={`${inModal ? '' : 'col-xs-offset-1 col-md-10 col-xs-10'}`}>
              {notification.title && <h6 className="notification-title">{notification.title}</h6>}
              {notification.content && (
                <div className="notification-content">{notification.content}</div>
              )}
            </div>
          </section>
        ))}
      </div>
    </div>
  );
};

export default NotificationBox;
